import { Reveal } from "@/components/Reveal";

const STATS = [
  { value: "18+", label: "Years on the road" },
  { value: "$4.2B", label: "Claims settled" },
  { value: "15-min", label: "FMCSA filings" },
  { value: "50", label: "States served" },
];

const ABOUT_IMG =
  "https://images.pexels.com/photos/13961751/pexels-photo-13961751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-16 sm:py-24">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
      <Reveal className="relative order-2 lg:order-1">
        <div className="absolute -left-5 -top-5 h-full w-full rounded-3xl border-2 border-brand-blue/15" />
        <div className="relative overflow-hidden rounded-3xl shadow-xl shadow-slate-900/10">
          <img
            src={ABOUT_IMG}
            alt="Overhead view of a coordinated truck fleet"
            className="aspect-[4/3] w-full object-cover"
            data-testid="about-fleet-image"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-brand-navy/40 via-transparent to-transparent" />
          <div className="absolute bottom-5 left-5 right-5">
            <div className="inline-flex items-center gap-3 rounded-2xl bg-white/92 px-4 py-3 backdrop-blur">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-blue font-display text-sm font-bold text-white">
                A+
              </span>
              <div>
                <p className="text-sm font-bold text-brand-navy">A+ rated carrier network</p>
                <p className="text-xs text-slate-500">Every policy backed by top-tier carriers</p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <p className="eyebrow">About Fleetguard</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-brand-navy sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
            Two decades keeping American freight covered.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            Fleetguard Insurance was built by people who know the freight industry from the inside —
            the dispatch boards, the weigh stations, the 2 a.m. breakdown calls. We write
            commercial truck coverage the way owner-operators need it: fast, honest, and priced for
            the long haul.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-slate-600">
            From a single rig to a national fleet, every client gets the same promise — instant
            FMCSA filings, live claims support around the clock, and a team that answers on the
            first ring.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-slate-200 bg-slate-200">
            {STATS.map((s) => (
              <div key={s.label} className="bg-white p-6" data-testid="about-stat">
                <p className="font-display text-3xl font-extrabold tracking-tight text-brand-blue sm:text-4xl">
                  {s.value}
                </p>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
